import {
  Box,
  Button,
  Card,
  Container,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { auth } from "service";
import { getTokenBySignUp } from "service/api";
import img_qaztrade_logo from "../../assets/img/qaztrade_logo_big.png";
import * as Yup from "yup";
import { useNavigate, Link } from "react-router-dom";
import { Formik } from "formik";
// import { PUBLIC_URL } from "config";

export const SignUp = () => {
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    bin: Yup.string().min(1).required("Обязательное поле"),
    email: Yup.string()
      .email("Некорректный Email")
      .required("Обязательное поле"),
    password1: Yup.string().min(8).required("Обязательное поле"),
    password2: Yup.string()
      .oneOf([Yup.ref("password1"), null as any], "Passwords must match")
      .required("Обязательное поле"),
  });

  return (
    <>
      <Box sx={{ bgcolor: "#F9FAFB", minHeight: "100vh" }}>
        <Container sx={{ py: "96px" }}>
          <Box
            sx={{
              m: "0 auto",
              width: "440px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box component={"img"} src={img_qaztrade_logo} height={"128px"} />
            <Typography fontWeight={"600"} fontSize={"30px"} mt={"12px"}>
              Регистрация
            </Typography>
            <Card sx={{ mt: "32px", p: "32px 40px", width: "100%" }}>
              <Formik
                initialValues={{
                  bin: "",
                  email: "",
                  password1: "",
                  password2: "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  try {
                    const token = await getTokenBySignUp({
                      email: values.email,
                      bin: values.bin,
                      password: values.password1,
                    });
                    auth.SetLogin(token);
                    navigate("/");
                  } catch (error) {
                    alert(error);
                  }
                }}
              >
                {({ handleSubmit, errors, handleChange }) => (
                  <form onSubmit={handleSubmit}>
                    <Box>
                      <Box>
                        <InputLabel sx={{ mb: "6px" }}>
                          БИН/ИИН организации*
                        </InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder=""
                          name="bin"
                          error={errors["bin"] ? true : false}
                          onChange={handleChange}
                        />
                      </Box>
                      <Box mt={"20px"}>
                        <InputLabel sx={{ mb: "6px" }}>
                          Электронный адрес*
                        </InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Введите электронный адрес"
                          name="email"
                          error={errors["email"] ? true : false}
                          onChange={handleChange}
                        />
                      </Box>
                      <Box mt={"20px"}>
                        <InputLabel sx={{ mb: "6px" }}>
                          Придумайте пароль*
                        </InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder=""
                          type={"password"}
                          name="password1"
                          error={errors["password1"] ? true : false}
                          onChange={handleChange}
                        />
                        <Typography mt={"8px"} color={"#475467"}>
                          Минимум 8 символов
                        </Typography>
                      </Box>
                      <Box mt={"20px"}>
                        <InputLabel sx={{ mb: "6px" }}>
                          Повторите пароль*
                        </InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder=""
                          type={"password"}
                          name="password2"
                          error={errors["password2"] ? true : false}
                          onChange={handleChange}
                        />
                      </Box>
                      <Box mt={"24px"}>
                        <Button variant="contained" fullWidth type="submit">
                          Зарегистрироваться
                        </Button>
                      </Box>
                    </Box>
                  </form>
                )}
              </Formik>
            </Card>
            <Box sx={{ mt: "32px", display: "flex" }}>
              <Typography fontWeight={"400"}>
                Уже есть аккаунт? <Link to={"/auth/signin"}>Войти</Link>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
